
let LifestyleActivity = Backbone.Model.extend(
    {
        defaults:
            {
                name: null,
                selected: false,
                days: [],
                duration: appConfig.lifestyle.duration.defaultValue
            },

        loadIn: function(activities) {
            let thisName = this.getName();
            let activity = activities.find((x) => x.getName() === thisName);
            if(activity !== undefined) {
                this.setSelected(activity.isSelected());
                this.setDays(activity.getDays());
                this.setDuration(activity.getDuration());
            }
            return this;
        },

        getName: function () {
            return this.get('name')
        },

        getDays: function () {
            return this.get('days');
        },

        getDuration: function () {
            return this.get('duration');
        },

        isSelected: function() {
            return this.get('selected');
        },

        setDays: function (days) {
            this.set('days', days);
        },

        setDuration: function(duration) {
            this.set('duration', parseInt(duration));
        },

        setSelected: function(isSelected) {
            this.set('selected', isSelected);
        },

        averageUtilisedHours: function () {
            let avg = this.getDays().length * this.getDuration() / 7.0 / 60.0;
            appLogAttr('LifestyleActivity->'+this.getName(), 'averageUtilisedHours', avg);
            return avg;
        }
    }
);

function CreateLifestyleActivity(attributes) {
    return new LifestyleActivity(attributes);
}


let LifestyleActivityList = Backbone.Collection.extend(
    {
        model: LifestyleActivity
    }
);
